'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createEssentials } from '@wix/fe-essentials-standalone';
import { RootEssentialsProvider } from '@wix/fe-essentials-standalone/react';

import type { ExperimentsBag } from '@wix/wix-experiments';

let queryClient: QueryClient;

function getQueryClient() {
  if (!queryClient) {
    queryClient = new QueryClient({
      defaultOptions: { queries: { staleTime: 60 * 1000 } },
    });
  }
  return queryClient;
}

export default function Providers({
  children,
  ...props
}: {
  children: React.ReactNode;
  language: string;
  artifactId: string;
  artifactVersion: string;
  experiments: ExperimentsBag;
  baseURL: string;
}) {
  const client = getQueryClient();

  const essentials = createEssentials({
    environment: {
      language: props.language,
      artifactId: props.artifactId,
      version: props.artifactVersion,
    },
    experiments: { bag: props.experiments },
    fedops: {},
    errorMonitor: {
      dsn: 'https://7236953e4400460e850ac619ca1c45aa@sentry.wixpress.com/3949',
    },
    httpClient: {
      baseURL: props.baseURL,
    },
  });

  return (
    <QueryClientProvider client={client}>
      <RootEssentialsProvider essentials={essentials}>
        {children}
      </RootEssentialsProvider>
    </QueryClientProvider>
  );
}
